<div id="employee-calendar" class="page-layout simple left-sidebar inner-sidebar inner-scroll">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-xs="row"
        fxLayoutAlign.gt-xs="space-between center">

        <!-- APP TITLE -->
        <div fxLayout="row" fxLayoutAlign="start center">

            <div class="logo" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                    description
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    {{'Calendar' | translate }}
                </span>
            </div>

        </div>
        <!-- / APP TITLE -->

    </div>
    <!-- / HEADER -->

    <!-- SELECTED BAR -->
    <!-- <selected-bar class="accent-600" *ngIf="hasSelectedContacts" [@slideInTop]></selected-bar> -->
    <!-- / SELECTED BAR -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56" fusePerfectScrollbar>

            <!-- CONTENT -->
            <div class="content">

                <div id="calendar" class="page-layout simple fullwidth">

                    <!-- HEADER -->
                    <div class="header p-16 p-sm-24">

                        <div class="header-content" fxLayout="row" fxLayoutAlign="space-between">

                            <div fxLayout="row">
                                <!-- <button mat-raised-button class="mat-accent" (click)="addEvent()" aria-label="Add event"
                                    [disabled]="addEventDisabled">
                                    <mat-icon>add</mat-icon>
                                    Add event
                                </button> -->
                            </div>

                            <!-- HEADER BOTTOM -->
                            <div class="header-bottom" fxLayout="row" fxLayoutAlign="center center"
                                [@animate]="{value:'*',params:{delay:'150ms'}}">

                                <button mat-icon-button class="arrow" mwlCalendarPreviousView [view]="view"
                                    [(viewDate)]="viewDate" (viewDateChange)="selectedDay = {date:$event}"
                                    aria-label="Previous" (click)="changeMonth(selectedDay)">
                                    <mat-icon>chevron_left</mat-icon>
                                </button>

                                <div class="title">
                                    {{ viewDate | calendarDate:(view + 'ViewTitle'):locale }}
                                </div>

                                <button mat-icon-button class="arrow" mwlCalendarNextView [view]="view"
                                    [(viewDate)]="viewDate" (viewDateChange)="selectedDay = {date:$event}"
                                    aria-label="Next" (click)="changeMonth(selectedDay)">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                            </div>
                            <!-- / HEADER BOTTOM -->
                        </div>

                        <!-- ADD EVENT BUTTON -->
                        <!-- <button mat-fab class="add-event-button mat-accent" (click)="addEvent()" aria-label="Add event"
            [@animate]="{value:'*',params:{delay:'300ms',scale:'0.2'}}">
            <mat-icon>add</mat-icon>
        </button> -->
                        <!-- / ADD EVENT BUTTON -->
                    </div>
                    <!-- / HEADER -->

                    <!-- CONTENT -->
                    <div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'200ms',y:'50px'}}">
                        <div [ngSwitch]="view">
                            <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [events]="events"
                                [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" [locale]="locale" weekStartsOn="1"
                                (dayClicked)="dayClicked($event.day)" (eventTimesChanged)="eventTimesChanged($event)"
                                (beforeViewRender)="beforeMonthViewRender($event)">
                            </mwl-calendar-month-view>
                            <!-- <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate"
                (viewDateChange)="selectedDay = {date:$event}" [events]="events" [refresh]="refresh"
                (dayClicked)="dayClicked($event.day)" (eventClicked)="editEvent('edit', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)">
            </mwl-calendar-week-view>
            <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate"
                (viewDateChange)="selectedDay = {date:$event}" [events]="events" [refresh]="refresh"
                (dayClicked)="dayClicked($event.day)" (eventClicked)="editEvent('edit', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)">
            </mwl-calendar-day-view> -->
                        </div>
                    </div>
                    <!-- / CONTENT -->
                </div>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->

</div>